/*--------------------------------------------*\
		Include Globally Useful JS Functions
\*--------------------------------------------*/

ThemeJS.Functions = (function ($, root) {

	function send_ajax_request(args) {
		args.data.nonce = ThemeJS.Variables.Ajax.nonce;
		$.post(ThemeJS.Variables.Ajax.url, args.data, function (response) {
			response = JSON.parse(response);
			if (!response.hasOwnProperty('data')) { response.data = {}; }
			if (response.success && typeof args.success == 'function') {
				args.success(response.data);
			} else if (!response.success && typeof args.error == 'function') {
				args.error(response.data);
			}
		});
	}

	function wp_rest_request(args) {
		let ajax_args = {
			method: (args.method ?? 'GET').toString().toUpperCase(),
			url: `${ThemeJS.Variables.WP_REST.root}${args.endpoint}`,
			data: args.data,
			contentType: 'application/json; charset=utf-8',
			beforeSend(xhr) {
				xhr.setRequestHeader('X-WP-Nonce', ThemeJS.Variables.WP_REST.nonce);
			},
			success(data) {
				if (typeof args.success == 'function') {
					args.success(data);
				}
			},
			error(data) {
				if (typeof args.error == 'function') {
					args.error(data);
				}
			},
			complete(data) {
				if (typeof args.complete == 'function') {
					args.complete(data);
				}
			}
		};
		if (ajax_args.method != 'GET') {
			ajax_args.dataType = 'json';
			ajax_args.data = JSON.stringify(ajax_args.data);
		}
		jQuery.ajax(ajax_args);
	}

	function get_query_parameter(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&#]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}

	let scrollbar_width = null;
	// taken from https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
	function get_scrollbar_width() {
		if (scrollbar_width === null) {
			let outer = document.createElement('div');
			outer.style.visibility = 'hidden';
			outer.style.overflow = 'scroll';
			outer.style.msOverflowStyle = 'scrollbar';
			document.body.appendChild(outer);
			let inner = document.createElement('div');
			outer.appendChild(inner);
			scrollbar_width = (outer.offsetWidth - inner.offsetWidth);
			outer.parentNode.removeChild(outer);
		}
		return scrollbar_width;
	}

	document.querySelector(':root').style.setProperty('--scrollbar-width', `${get_scrollbar_width()}px`);


	function init_select2(element, reinit = false) {
		let $element = $(element);
		if ($element.hasClass("select2-hidden-accessible")) {
			if (reinit) {
				$element.select2('destroy');
			} else {
				return;
			}
		}
		let $gf_placeholder = $('option.gf_placeholder', $element);
		if ($gf_placeholder.length) {
			$element.attr('data-placeholder', $gf_placeholder.text());
			$gf_placeholder.html('').removeClass('gf_placeholder');
		}
		let has_empty_option = $('option', $element).filter(function (i, opt) {
			let $opt = $(opt);
			let value = $opt.attr('value');
			return (value === undefined) ? !$opt.text() : !value;
		}).length;
		$element.select2({
			minimumResultsForSearch: 6,
			closeOnSelect: $(element).data().close_on_select ?? true,
			allowClear: ($element.attr('aria-required') != 'true' && has_empty_option),
			dropdownParent: $element.parent(),
			templateResult: function (state, li) {
				if (state.element) {
					$(li).css('--depth', parseInt(state.element.attributes['data-depth']?.value));
				}
				return state.text;
			}
		});
	}
	$('select').each(function () {
		init_select2(this);
	});


	function get_extension(path) {
		const ind = path.lastIndexOf('.');
		return (ind > 0) ? path.substring(ind + 1) : null;
	}


	function format_bytes(bytes, decimals = 2) {
		if (!+bytes) return '0 Bytes';

		const k = 1024
		const dm = decimals < 0 ? 0 : decimals
		const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

		const i = Math.floor(Math.log(bytes) / Math.log(k))

		return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
	}


	return {
		send_ajax_request,
		wp_rest_request,
		get_query_parameter,
		init_select2,
		get_extension,
		format_bytes,
	}

})(jQuery, this);